<template>
    <div class="text-center">
      <v-dialog v-model="dialog" max-width="500" persistent>
        <v-card>
          <v-card-title class="text-h5 blue darken-3 white--text">
            Completar los datos
          </v-card-title>
  
          <v-card-text> 
            <p></p>
            <v-text-field label="Fecha de entrega de documentos:" v-model="fecha_presen"  type="date" prefix="el:" hide-details />
            <p class="mt-8"></p>
            <v-checkbox class="py-0 my-0" v-model="form_admision" label="Formulario De Admisión"/> 
            <v-checkbox class="py-0 my-0" v-model="cedula" label="Copia Cedula personal o Pasaporte" />
            <v-checkbox class="py-0 my-0" v-model="fotografias" label="Dos Fotografias tamaño Carnet" />
            <v-checkbox class="py-0 my-0" v-model="diploma" label="Original y Copia Diploma Bachiller (Extranjeros Validado)" />
            <v-checkbox class="py-0 my-0" v-model="creditos" label="Original y Copia de Créditos" />
            <v-checkbox class="py-0 my-0" v-model="cert_salud" label="Certificado Buena Salud" />
          </v-card-text>
  
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green" outlined @click="enviar()"> Aceptar </v-btn>
            <v-btn color="red" outlined @click="cerrar()"> Cerrar </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
</template>
  
<script>

export default {
    data() {
        return { 
            dialog: false,  
            fecha_presen: {}, 
            form_admision: false,
            cedula: false,
            fotografias: false,
            diploma: false,
            creditos: false,
            cert_salud: false,
            resolvePromise: null,
        };
    },
    methods: {
        async openmodal(p) { 
          this.proy = p
          this.dialog = true; 
          this.hoy()
          return new Promise((resolve) => {
              this.resolvePromise = resolve;
          });
        },
        hoy(){
          const fechaActual = new Date(); 
          const año = fechaActual.getFullYear();
          const mes = String(fechaActual.getMonth() + 1).padStart(2, '0'); 
          const dia = String(fechaActual.getDate()).padStart(2, '0'); 
          const fechaFormateada = `${año}-${mes}-${dia}`;
          this.fecha_presen = fechaFormateada;
        }, 

        cerrar(){
          this.resolvePromise(false);
          this.dialog = false;
        },
        enviar(){ 
            if(!this.fecha_presen) return 
            const fs = this.fecha_presen.split('-')
            const input = {
                fecha_presen: `${fs[2]} / ${fs[1]} / ${fs[0]}`,
                form_admision: this.form_admision,
                cedula: this.cedula,
                fotografias: this.fotografias,
                diploma: this.diploma,
                creditos: this.creditos,
                cert_salud: this.cert_salud,
                resolvePromise: this.resolvePromise,
            }
            this.resolvePromise(input);
            this.dialog = false;
        }
    }
};
</script>
  